export default "__VITE_ASSET__DWeZUaWU__"